<template>
  <template v-if="singleStyle">
    <div class="legend" v-if="typeof singleStyle.color === 'string'"
    :style="{ border: singleStyle.border ? ' solid 2px ' + (singleStyle.color.includes('#') || singleStyle.color.includes('rgb') ? '' : '#') + singleStyle.color : '',
    'backgroundColor': singleStyle.fill ? (singleStyle.color.includes('#') || singleStyle.color.includes('rgb') ? '' : '#') + singleStyle.color : ''}"
    ></div>
    <span class="legend-header">{{legendRow.name}}</span>
  </template>
  <template v-if="listStyle">
    <div v-for="(layer, layerIndex) in listStyle?.segments" class="legend-row subRow" :key="'layer' + layerIndex">
      <div class="legend" :class="[listStyle.symbol, 'size' + layer.size]" :style="{'background-color': layer.color}"></div>
      <span v-if="listStyle.type === 'range'">{{layer.range}}  </span> {{legendRow.type}}
      <span v-if="listStyle.type === 'category'">{{layer.category}}</span>
    </div>
  </template>
</template>

<script>
/* this is a rendering compnent to display a legend row, either a header or a detail range/category information */
export default {
  name: 'legend-row',
  props: ['singleStyle', 'listStyle', 'legendRow', 'allowHideLayer']
}
</script>
<style scoped>
.legend {
  width: 15px;
  height: 15px;
  display: inline-block;
  margin-right: 3px;
}
.legend-row.subRow {
  margin-left: 10px;
}
.legend-header {
  font-weight: 550;
  font-size: 1rem;
}

.legend.circle {
  border-radius: 100px;
}
.legend.circle.size2 {
  width: 5px;
  height: 5px;
}
.legend.circle.size3,
.legend.circle.size4 {
  width: 8px;
  height: 8px;
}
</style>
